import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ToastState {
  type: 'success' | 'error' | 'warning';
  message: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private _toast$ = new Subject<ToastState | null>();
  readonly toast$ = this._toast$.asObservable();

  private timer: any;

  show(type: 'success' | 'error' | 'warning', message: string, duration = 3000): void {
    clearTimeout(this.timer);
    this._toast$.next({ type, message });
    this.timer = setTimeout(() => this._toast$.next(null), duration);
  }

  success(message: string, duration = 3000): void {
    this.show('success', message, duration);
  }

  error(message: string, duration = 3000): void {
    this.show('error', message, duration);
  }

  warning(message: string, duration = 3000): void {
    this.show('warning', message, duration);
  }
}
